import { Ad } from "@models/Ad.model";
import AdCard from "@/shared/components/AdCard";
import type { AdCardMode } from "@/shared/components/AdCard/types";

const MODES: AdCardMode[] = ["compact", "detail", "full"];

const mockAds: Ad[] = [
    new Ad({
        id: 9001, name: "Product Shot A", type: "image",
        content: {
            image_id: 1, layer_id: 1,
            copy_text: "Built for the daily grind. Engineered to last, priced fairly.",
            link_headline: "The daily carry",
            link_description: "store.brand.com",
            cta_text: "Shop now",
            link: "https://store.brand.com",
        } as any,
    } as any),
    new Ad({
        id: 9002, name: "Summer Launch Hero", type: "video",
        content: {
            video_id: 1, thumbnail_id: 1, layer_id: 1,
            copy_text: "Registration is open! Students who apply this week get priority placement.",
            link_headline: "Register before [DATE].",
            link_description: "[School name]",
            cta_text: "Learn more",
            link: "https://brand.com/register",
        } as any,
    } as any),
    new Ad({
        id: 9003, name: "Cart Abandon SMS", type: "sms",
        content: {
            text: "Hey! You left something behind in your cart. Finish checkout in the next hour and we'll cover shipping on us. This offer expires at 5pm today. Reply STOP to opt out anytime.",
        } as any,
    } as any),
    new Ad({
        id: 9004, name: "Welcome Series #1", type: "email",
        content: {
            html: "<p>Thanks for joining us. Here's a quick tour of what's inside and why we think you'll love it. This week we're highlighting the new arrivals and a few subscriber-only discounts you won't want to miss.</p>",
        } as any,
    } as any),
];

export default function AdCardDemoPage() {
    return (
        <div style={{ padding: 24, background: "#f5f5f7", minHeight: "100vh" }}>
            <h1 style={{ fontSize: 20, marginBottom: 24 }}>AdCard — visual verification</h1>
            {MODES.map((mode) => (
                <section key={mode} style={{ marginBottom: 32 }}>
                    <h2 style={{ fontSize: 13, fontWeight: 700, textTransform: "uppercase", color: "#6b7280", marginBottom: 12 }}>
                        {mode}
                    </h2>
                    <div style={{ display: "flex", gap: 14, alignItems: "stretch", flexWrap: "wrap" }}>
                        {mockAds.map((ad) => (
                            <div key={ad.id} style={{ width: 280 }}>
                                <AdCard ad={ad} mode={mode} />
                            </div>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}
